// @ vendors
const PropTypes = require('prop-types');
const React = require('react');

// @helpers
const { FormattedText, formatText } = require('core/i18n').i18n;

// @ components
const { HireInformation } = require('components/hire/hireInformation/hireInformation');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const ContactCenterRender = require('components/conditionalRender/contactCenterRender');
const ContactCenterValidationCards = require('components/hire/contactCenterValidationCards/contactCenterValidationCards');

//@ constants
const { FIRST_STEP } = require('constants/index');
const getCardsPreContractPdfData = require('constants/cardsPreContractualsPdf');
const { DIAMOND_PACK_PRODUCT_ALIAS,
    PRODUCT_HIRING_COMPONENT_ID } = require('constants/hiringProductInformation');
const { GC, CREDIT_CARD_REVOLVING_PROCESS } = require('constants/flagBasedFeatures');

class HireCardDiamondPackStep1 extends React.Component {

    componentDidMount() {
        const {
            flagBasedFeatures,
            requestPDFMerge,
            setTermsAndCondsText,
        } = this.props;

        if (!__CONTACT_CENTER__) {
            const pdfurls = getCardsPreContractPdfData()['diamond_pack_card'].preContractPdfLink;
            const product = {
                type: '501',
                subtype: '002',
                standard: '0000003'
            };
            const showIneAndRevolving = flagBasedFeatures.get(CREDIT_CARD_REVOLVING_PROCESS);
            if (!showIneAndRevolving) {
                requestPDFMerge(pdfurls, [product]);
            }

        } else {
            //This action is also called in the last step of the current hiring, if you update one remeber that maybe you should update the other one
            setTermsAndCondsText('hireCardDiamondPack-step4CheckboxText');
        }
    }

    buildLegalConfirmationSection() {
        const { showIneAndRevolving } = this.props;
        if (!__CONTACT_CENTER__ || showIneAndRevolving) return null;

        const {
            contractName,
            handleAgreementCheckboxChange,
            immHireCardDiamondPack,
            sendMailParams,
        } = this.props;

        const immStep = immHireCardDiamondPack.getIn(['steps', FIRST_STEP]);
        const agreementLabel = <FormattedText value="hireCardDiamondPack-step4CheckboxText" />;
        const agreementErrorMsg = formatText('hireCardDiamondPack-step4CheckboxErrorMsg');

        return (
            <ContactCenterValidationCards
                agreementErrorMsg={agreementErrorMsg}
                agreementLabel={agreementLabel}
                contractName={contractName}
                handleAgreementCheckboxChange={handleAgreementCheckboxChange}
                immStep={immStep}
                sendMailParams={sendMailParams}
            />
        );
    }

    render() {
        const { immHireInformation, gestorCrossEnabled, flagBasedFeatures } = this.props;
        const legalConfirmationSection = this.buildLegalConfirmationSection();
        let productInformationComponent;
        if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
            productInformationComponent = (
                <React.Fragment>
                    <HiringProductInformation
                        productAlias={DIAMOND_PACK_PRODUCT_ALIAS}
                        productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </React.Fragment>
            )
        } else {
            productInformationComponent = (
                <article className="hire-card-diamond-pack__step-one">
                    <FormattedText
                        className="hire-card-diamond-pack__step-title"
                        value="hireCardDiamondPack-step1Title"
                    />

                    {/* Enrique Álvarez Fernánde, At the moment the Diamond pack is not working. The hireCmsKey must be migrated */}
                    <HireInformation
                        collectiveEnabled={__CONTACT_CENTER__}
                        collectiveLocation="Contrataciones_Paso_colectivos_diamondpack_1"
                        hireCmsKey={this.props.hireCmsKey}
                        immHireInformation={immHireInformation}
                    />
                    <ContactCenterRender>
                        {legalConfirmationSection}
                    </ContactCenterRender>
                </article>
            )
        }
        return (
            <div>
                {productInformationComponent}
            </div>
        );
    }
}

HireCardDiamondPackStep1.propTypes = {
    contractName: PropTypes.string,
    flagBasedFeatures: PropTypes.object.isRequired,
    gestorCrossEnabled: PropTypes.bool,
    handleAgreementCheckboxChange: PropTypes.func,
    hireCmsKey: PropTypes.string.isRequired,
    immHireCardDiamondPack: PropTypes.object,
    immHireInformation: PropTypes.object.isRequired,
    requestPDFMerge: PropTypes.func.isRequired,
    sendMailParams: PropTypes.object,
    setTermsAndCondsText: PropTypes.func.isRequired,
    showIneAndRevolving: PropTypes.bool,
};

module.exports = HireCardDiamondPackStep1;
